import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  initateLoading: false,
  error: false,
  truckUnloadSummary: [],
  gateCheckReport: [],
  adfatReport: [],
  adfatReportResponse: [],
  vendorList: [],
  carrierList: [],
  truckUnloadStats: [],
  scheduledLoadStatusList: [],
  selectedReportObj: {},
  imsReceiptsData: [],
  operationObj: {},
}

export const ReportsReducerSlice = createSlice({
  name: 'reportsReducerSlice',
  initialState,
  reducers: {
    updateImsReceiptsData: (state, action) => {
      state.imsReceiptsData = action.payload;
    },
    cleanupImsReceiptsData: (state) => {
      state.initateLoading = false;
      state.imsReceiptsData = [];
      state.error = false;
      state.operationObj = {};
    },
    updateLoader: (state, action) => {
      state.initateLoading = action.payload
    },
    updateError: (state, action) => {
      state.error = action.payload
    },
    updateTruckUnloadSummaryList: (state, action) => {
      state.truckUnloadSummary = action.payload
    },
    updateADFATReport: (state, action) => {
      state.adfatReport = action.payload
    },
    updateADFATReportResponse: (state, action) => {
      state.adfatReportResponse = action.payload
    },
    updateCarrierList: (state, action) => {
      state.carrierList = action.payload
    },
    updateVendorList: (state, action) => {
      state.vendorList = action.payload
    },
    updateTruckUnloadStatsList: (state, action) => {
      state.truckUnloadStats = action.payload
    },
    updateScheduledLoadStatusList: (state, action) => {
      state.scheduledLoadStatusList = action.payload
    },
    updateSelectedReport: (state, action) => {
      state.selectedReportObj = action.payload
    },
    clearTruckUnloadSummaryList: (state, action) => {
      state.truckUnloadSummary = [];
    },
    clearTruckUnloadStatsList: (state, action) => {
      state.truckUnloadStats = [];
    },
    updateGateCheckReportList: (state, action) => {
      state.gateCheckReport = action.payload
    },
    clearGateCheckReportList: (state, action) => {
      state.gateCheckReport = [];
    },
    updateOperationObj: (state, action) => {
      state.operationObj = action.payload
    }
  }
});

export const { updateImsReceiptsData, cleanupImsReceiptsData, updateError, updateResponseData, updateTruckUnloadSummaryList, updateADFATReport, updateLoader, updateCarrierList, updateVendorList, updateTruckUnloadStatsList, updateScheduledLoadStatusList, updateSelectedReport, updateADFATReportResponse, clearTruckUnloadSummaryList, clearTruckUnloadStatsList, updateOperationObj, updateGateCheckReportList, clearGateCheckReportList } = ReportsReducerSlice.actions;

// Selectors
export const getReportsSelector = (state) => {
  return state.reportsReducerSlice;
};


export default ReportsReducerSlice.reducer;
